"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BounceTypeCode = exports.BounceType = void 0;
var BounceType;
(function (BounceType) {
    BounceType["HardBounce"] = "HardBounce";
    BounceType["Transient"] = "Transient";
    BounceType["Unsubscribe"] = "Unsubscribe";
    BounceType["Subscribe"] = "Subscribe";
    BounceType["AutoResponder"] = "AutoResponder";
    BounceType["AddressChange"] = "AddressChange";
    BounceType["DnsError"] = "DnsError";
    BounceType["SpamNotification"] = "SpamNotification";
    BounceType["OpenRelayTest"] = "OpenRelayTest";
    BounceType["Unknown"] = "Unknown";
    BounceType["SoftBounce"] = "SoftBounce";
    BounceType["VirusNotification"] = "VirusNotification";
    BounceType["ChallengeVerification"] = "ChallengeVerification";
    BounceType["BadEmailAddress"] = "BadEmailAddress";
    BounceType["SpamComplaint"] = "SpamComplaint";
    BounceType["ManuallyDeactivated"] = "ManuallyDeactivated";
    BounceType["Unconfirmed"] = "Unconfirmed";
    BounceType["Blocked"] = "Blocked";
    BounceType["SMTPApiError"] = "SMTPApiError";
    BounceType["InboundError"] = "InboundError";
    BounceType["DMARCPolicy"] = "DMARCPolicy";
    BounceType["TemplateRenderingFailed"] = "TemplateRenderingFailed";
})(BounceType = exports.BounceType || (exports.BounceType = {}));
var BounceTypeCode;
(function (BounceTypeCode) {
    BounceTypeCode[BounceTypeCode["HardBounce"] = 1] = "HardBounce";
    BounceTypeCode[BounceTypeCode["Transient"] = 2] = "Transient";
    BounceTypeCode[BounceTypeCode["Unsubscribe"] = 16] = "Unsubscribe";
    BounceTypeCode[BounceTypeCode["Subscribe"] = 32] = "Subscribe";
    BounceTypeCode[BounceTypeCode["AutoResponder"] = 64] = "AutoResponder";
    BounceTypeCode[BounceTypeCode["AddressChange"] = 128] = "AddressChange";
    BounceTypeCode[BounceTypeCode["DnsError"] = 256] = "DnsError";
    BounceTypeCode[BounceTypeCode["SpamNotification"] = 512] = "SpamNotification";
    BounceTypeCode[BounceTypeCode["OpenRelayTest"] = 1024] = "OpenRelayTest";
    BounceTypeCode[BounceTypeCode["Unknown"] = 2048] = "Unknown";
    BounceTypeCode[BounceTypeCode["SoftBounce"] = 4096] = "SoftBounce";
    BounceTypeCode[BounceTypeCode["VirusNotification"] = 8192] = "VirusNotification";
    BounceTypeCode[BounceTypeCode["ChallengeVerification"] = 16384] = "ChallengeVerification";
    BounceTypeCode[BounceTypeCode["BadEmailAddress"] = 100000] = "BadEmailAddress";
    BounceTypeCode[BounceTypeCode["SpamComplaint"] = 100001] = "SpamComplaint";
    BounceTypeCode[BounceTypeCode["ManuallyDeactivated"] = 100002] = "ManuallyDeactivated";
    BounceTypeCode[BounceTypeCode["Unconfirmed"] = 100003] = "Unconfirmed";
    BounceTypeCode[BounceTypeCode["Blocked"] = 100006] = "Blocked";
    BounceTypeCode[BounceTypeCode["SMTPApiError"] = 100007] = "SMTPApiError";
    BounceTypeCode[BounceTypeCode["InboundError"] = 100008] = "InboundError";
    BounceTypeCode[BounceTypeCode["DMARCPolicy"] = 100009] = "DMARCPolicy";
    BounceTypeCode[BounceTypeCode["TemplateRenderingFailed"] = 100010] = "TemplateRenderingFailed";
})(BounceTypeCode = exports.BounceTypeCode || (exports.BounceTypeCode = {}));
//# sourceMappingURL=Bounce.js.map